export function isEquivalent(source: any, target: any): boolean {
  if (!source || !target) {
    return false;
  }

  // Create arrays of property names
  var sourceProps = Object.getOwnPropertyNames(source);
  var targetProps = Object.getOwnPropertyNames(target);

  // If number of properties is different,
  // objects are not equivalent
  if (sourceProps.length != targetProps.length) {
    return false;
  }

  for (var i = 0; i < sourceProps.length; i++) {
    const propName = sourceProps[i];
    const propValue = source[propName];

    if (propValue && typeof propValue === 'object') {
      return isEquivalent(propValue, target[propName]);
    }

    // If values of same property are not equal,
    // objects are not equivalent
    if (source[propName] !== target[propName]) {
      return false;
    }
  }

  // If we made it this far, objects
  // are considered equivalent
  return true;
}
